module.exports = __webpack_public_path__ + "img/04-Limousine.1c92a893.svg";